import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TalkToUsBtnComponent } from './components/talk-to-us-btn/talk-to-us-btn.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonTalktousModalModule } from '../common-talktous-modal/common-talktous-modal.module';

@NgModule({
  declarations: [TalkToUsBtnComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    CommonTalktousModalModule
  ],
  exports: [TalkToUsBtnComponent]
})
export class TalkToUsBtnModule { }
